import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const OtherPaymentService = () => {
  const [serviceName, setServiceName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [alert, setAlert] = useState({ message: '', type: '' });
  const [rowData, setRowData] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/get_other_payment_services`);
      const fetchedData = response.data.map((service) => ({
        ...service,
        isActive: service.isActive === 1 ? 1 : 0, // Ensure isactive is mapped correctly
      }));
      setRowData(fetchedData);
    } catch (err) {
      console.error('Error fetching services:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
  
    // const loggedInUser = localStorage.getItem('username');

         // Retrieve logged-in username from localStorage
         const loggedInUser = localStorage.getItem("username");
        
         // Prevent submission if user is not logged in
         if (!loggedInUser) {
             alert("Please log in before submitting payment details.");
             return;
         }

         
    if (loggedInUser !== 'admin' && loggedInUser !== 'amaravathi') {
      showAlert('You do not have permission to add a service.', 'error');
      setLoading(false);
      return;
    }
    
  
    try {
      const response = await axios.post(`${API_BASE_URL}/api/add_other_payment_service`, {
        service: serviceName,
        cby: loggedInUser,
        isActive: 1, // Set new service as active by default
      });
  
      if (response.status === 201) {
        showAlert('Service added successfully!', 'success');
        setServiceName('');
        fetchServices();
      } else {
        setError('Failed to add service. Please try again.');
      }
    } catch (err) {
      setError('An error occurred while adding the service.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  

  const handleStatusEdit = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
  };

  const confirmStatusChange = async () => {
    if (!selectedService) return;
    const loggedInUser = localStorage.getItem('username');
    const updatedStatus = selectedService.isActive === 1 ? 0 : 1;

    try {
      await axios.put(`${API_BASE_URL}/api/update_other_payment_service_status/${selectedService.id}`, {
        isActive: updatedStatus,
        mby: loggedInUser,
      });

      setRowData(
        rowData.map((row) =>
          row.id === selectedService.id ? { ...row, isActive: updatedStatus } : row
        )
      );

      showAlert(
        `Service status updated to ${updatedStatus === 1 ? 'Active' : 'Inactive'}`,
        'success'
      );
    } catch (error) {
      showAlert('Error updating status', 'error');
      console.error('Error updating status:', error);
    } finally {
      setIsModalOpen(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const showAlert = (message, type) => {
    setAlert({ message, type });
    setTimeout(() => {
      setAlert({ message: '', type: '' });
    }, 3000);
  };

//   const handleDelete = async (service) => {
//     if (!window.confirm(`Are you sure you want to delete "${service.service}"?`)) {
//         return;
//     }

//     try {
//         await axios.delete(`${API_BASE_URL}/api/delete_other_payment_service/${service.id}`);
//         setRowData(rowData.filter((row) => row.id !== service.id));
//         showAlert('Service deleted successfully!', 'success');
//     } catch (error) {
//         showAlert('Error deleting service', 'error');
//         console.error('Error deleting service:', error);
//     }
// };

const columnDefs = [
    { headerName: 'S.No', valueGetter: (params) => params.node.rowIndex + 1, flex: 1 },
    {
        headerName: 'Status',
        field: 'isActive',
        valueFormatter: (params) => (params.value === 1 ? 'Active' : 'Inactive'),
        flex: 1,
        sortable: true,
        filter: true,
        cellStyle: (params) => ({
            color: params.value === 1 ? 'green' : 'red',
            fontWeight: 'bold',
        }),
        cellRenderer: (params) => (
            <div className="flex items-center space-x-2">
                <span>{params.value === 1 ? 'Active' : 'Inactive'}</span>
                <button
                    className="text-blue-600 hover:underline"
                    onClick={() => handleStatusEdit(params.data)}
                >
                    🖉
                </button>
            </div>
        ),
    },
    { headerName: 'Service Name', field: 'service', flex: 2 },
    { headerName: 'Added by', field: 'cby', flex: 2 },
    {
        headerName: 'Actions',
        field: 'id',
        flex: 1,
        cellRenderer: (params) => (
            <button
                className="text-red-600 hover:underline"
                // onClick={() => handleDelete(params.data)}
            >
                ❌ Delete
            </button>
        ),
    },
];

  return (
    <div className="bg-gray-100 p-4">
      <div className="max-w-xl mx-auto bg-white shadow-md rounded mb-4 mt-8">
        <div className="bg-teal-500 text-white px-5 py-3 rounded-t">
          <h2 className="text-xl font-bold">Add New Service</h2>
        </div>
        <form className="p-6 flex flex-col space-y-3" onSubmit={handleSubmit}>
          <div>
            <label className="block text-gray-700">Service Name:<span className="text-red-500">*</span></label>
            <input
              type="text"
              value={serviceName}
              onChange={(e) => setServiceName(e.target.value)}
              placeholder="Enter service name"
              className="w-full p-2 mt-2 border border-gray-300 rounded"
              required
            />
          </div>
          <div className="flex justify-end">
            <button type="submit" className="px-4 py-2 bg-teal-500 text-white rounded" disabled={loading}>
              {loading ? 'Adding...' : 'Add Service'}
            </button>
          </div>
        </form>
      </div>

      <div className="max-w-5xl mx-auto bg-white shadow-md rounded mb-6">
        <div className="p-6">
          <h2 className="text-teal-500 text-xl font-bold mb-4">View Services</h2>
          <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              defaultColDef={{ sortable: true, filter: true }}
              pagination={true}
              paginationPageSize={5}
            />
          </div>
        </div>
      </div>

      {alert.message && (
        <div className={`fixed top-20 right-4 px-5 py-3 text-white rounded-lg shadow-lg transition-all duration-300 z-50 ${alert.type === 'success' ? 'bg-green-500' : 'bg-red-500'}`}>
          <span>{alert.message}</span>
        </div>
      )}

      {/* Confirmation Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg text-center">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to change the status?
            </p>
            <div className="flex justify-center space-x-4">
              <button className="px-4 py-2 bg-green-500 text-white rounded" onClick={confirmStatusChange}>
                Yes
              </button>
              <button className="px-4 py-2 bg-red-500 text-white rounded" onClick={closeModal}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OtherPaymentService;
